export type PreferencesWindowProps = Record<string, never>
